const ScrollToTopOnClick = {
  mounted() {
    this.el.addEventListener('click', this.scrollToTop)
  },
  destroyed() {
    this.el.removeEventListener('click', this.scrollToTop)
  },
  scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  },
}

export default ScrollToTopOnClick
